/* globals data, serverParams */
import Table from 'bam-node-savant-table/table'

import './pitch-timer-infractions-viz'

const { entity_code } = serverParams

const is_team_type = ['Team', 'Opp'].includes(entity_code)
const tableDivId = 'pitch_timer_violations_table'

let currentData = data.slice()

function loadTable(data) {
    const width = document.getElementById(tableDivId).offsetWidth
    let repeatHeader = false
    if (width <= 768) {
        repeatHeader = 15
    }
    const defaultSort = document.getElementById('sort').value
    const defaultSortDirection = document.getElementById('sortDir').value

    // const keys = Object.keys(data[0]).slice(19, 40)

    // const allHeaders = keys.map((key) => ({
    //     name: key,
    //     field: key,
    //     headerClass: 'th-component-header align-center th-vertical-bottom',
    //     fieldClass: 'tr-data',
    //     type: 'number',
    //     displayFn: (val) => {
    //         if (key.includes('rate')) {
    //             return `${(val * 100).toFixed(1)}`
    //         }
    //         if (key.includes('diff')) {
    //             return `${val.toFixed(2)}`
    //         }

    //         if (key.includes('runs')) {
    //             return `${val.toFixed(1)}`
    //         }
    //         return val
    //     },
    // }))

    const headers = [
        {
            name: is_team_type ? 'Team' : 'Player',
            field: 'entity_name',
            customSortField: 'entity_name',
            headerClass: `th-component-header align-left th-vertical-bottom table-static-column`,
            fieldClass: `tr-data align-left table-static-column`,
            defaultSortDir: 'asc',
            displayFn: (entity_name, d) =>
                is_team_type
                    ? entity_name
                    : `<a href="/savant-player/${d.entity_id}">${entity_name}</a>`, // what levels of unsafe is this?
        },
        // Only for teams
        {
            name: '',
            field: 'entity_name',
            headerClass: `th-component-header ${is_team_type ? '' : ' hide'}`,
            fieldClass: `tr-data ${is_team_type ? '' : ' hide'}`,
            photo: '<img class="table-team-logo" src="https://www.mlbstatic.com/team-logos/{1}.svg" onerror="this.onerror=\'\';this.src=\'/site-core/images/savant-mlb.svg\'" />',
            photoId: 'entity_id',
            defaultSortDir: 'asc',
            photoOnly: true,
        },
        {
            name: 'Total Pitches',
            field: 'N_pitches',
            headerClass: `th-component-header align-center th-vertical-bottom border-right`,
            fieldClass: `tr-data border-right`,
            type: 'number',
            displayFn: (val) => val.toLocaleString(),
        },
        {
            name: 'All',
            field: 'N_time_violations',
            headerClass: `th-component-header align-center th-vertical-bottom border-right border-left`,
            fieldClass: `tr-data border-right border-left`,
            type: 'number',
        },
        {
            name: 'Pitcher Timer',
            field: 'N_pitcher_pitch_timer',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data`,
            type: 'number',
            types: ['Cat', 'Pit', 'Team', 'Opp'],
        },
        {
            name: 'Batter Timer',
            field: 'N_batter_pitch_timer',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data`,
            type: 'number',
            types: ['Bat', 'Team', 'Opp'],
        },
        {
            name: 'Batter Attempted <br/>Second Timeout',
            field: 'N_batter_timeout',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data`,
            type: 'number',
            types: ['Bat', 'Team', 'Opp'],
        },
        {
            name: 'Catcher Timer',
            field: 'N_catcher_pitch_timer',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data`,
            type: 'number',
            types: ['Pit', 'Cat', 'Team', 'Opp'],
        },
        {
            name: 'Defensive Shift',
            field: 'N_defensive_shift',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data`,
            type: 'number',
            types: ['Team', 'Opp'],
        },
        {
            name: 'Pitches / Infraction',
            field: 'rate',
            headerClass: `th-component-header align-center th-vertical-bottom`,
            fieldClass: `tr-data`,
            type: 'number',
            displayFn: (val) => {
                if (val) {
                    return Math.round(val).toLocaleString()
                }

                return '--'
            },
        },
    ]

    const filteredHeaders = headers.filter(({ types }) => {
        if (!types) {
            return true
        }

        return types.includes(entity_code)
    })

    const secondaryHeaders = []
    // eslint-disable-next-line no-new
    new Table({
        id: tableDivId,
        repeatHeader,
        secondaryHeaders,
        headers: filteredHeaders,
        highlightFalsy: false,
        data,
        uniqueId: 'entity_id', // this can't have dashes in it
        defaultSort,
        defaultSortDirection,
        sortClass: 'column-sort',
        showRank: true,
        sortCallback(column, _, { state }) {
            const url = new URL(window.location)
            url.searchParams.set('sortColumn', column)
            url.searchParams.set('sortDirection', state)
            window.history.replaceState('', '', url.toString())
        },
    })
}

const $input = document.querySelector('.table-search')

if (data && data.length) {
    loadTable(currentData)

    if ($input) {
        $input.addEventListener('input', (e) => {
            currentData = getFilteredData(e.target.value)
            loadTable(currentData)
        })
    }
}

// TODO: If this goes on in 2024, we might need to actually disable these, rather than being lazy and pretending.
document.getElementById('ddlGroup').addEventListener('change', (e) => {
    const teamTypes = ['Opp', 'Team']

    if (teamTypes.includes(e.target.value)) {
        document.querySelectorAll('.hide-team').forEach((el) => {
            // eslint-disable-next-line no-param-reassign
            el.style.opacity = 0.2
        })
    } else {
        document.querySelectorAll('.hide-team').forEach((el) => {
            // eslint-disable-next-line no-param-reassign
            el.style.opacity = 1
        })
    }
})

// Trigger a change event
document.getElementById('ddlGroup').dispatchEvent(new Event('change'))

function populateUrl() {
    const parameters = {
        type: document.getElementById('ddlGroup').value,
        season: document.getElementById('ddlSeason').value,
        min_pitches: document.getElementById('ddlMinPitches').value,
        include_zeroes: document.getElementById('include_zeroes').checked
            ? 1
            : 0,
    }

    const urlParams = new URLSearchParams(parameters)

    return `${window.location.pathname}?${urlParams.toString()}`
}

document.getElementById('btn-update').addEventListener('click', () => {
    window.location = populateUrl()
})

function getFilteredData(search) {
    const normalized_search = search
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .toLowerCase()

    return data.filter((d) => {
        const name = d.entity_name
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()

        return name.includes(normalized_search)
    })
}

document.getElementById('btn-csv').addEventListener('click', () => {
    window.location.href = window.location.search
        ? `${window.location.href}&csv=true`
        : `${window.location.href}?csv=true`
})
